import {
  useGetHeroModelByIdQuery,
  useUpdateHeroModelMutation,
} from "@/app/features/HeroModel/HeroModelApiSlice";
import FormInput from "@/components/forms/FormInput";
import {
  Box,
  Button,
  Container,
  Skeleton,
  Stack,
  Typography,
} from "@mui/material";
import { Form, Formik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import * as Yup from "yup";

const validationSchema = Yup.object().shape({
  carId: Yup.string().required().min(2).max(50).label("carId").trim(),
});

export default function ViewHeroModelPage() {
  const params = useParams();
  const { data, isLoading, isError, error } = useGetHeroModelByIdQuery(
    params.id
  );

  const navigate = useNavigate();

  const [updatePopularSearch, { isLoading: isUpdating }] =
    useUpdateHeroModelMutation();

  const handleSubmit = async (inputs) => {
    try {
      const result = await updatePopularSearch({
        id: params.id,
        data: { carId: inputs.carId.trim() },
      });

      if (result && result.data) {
        toast.success(result.data.message);
        navigate("/hero-model");
      } else if (result && result.error) {
        toast.error(result.error.data.message);
      }
    } catch (error) {
      console.log("Error :", error);
      toast.error(error?.message || "Something went wrong");
    }
  };

  const heroModel = data?.data?.data;

  console.log("data: ", heroModel);

  if (isLoading) {
    return (
      <Skeleton
        sx={{
          transform: "scale(1, 1.0)",
          transformOrigin: "0% 0%",
        }}
        width="100%"
        height="600px"
      />
    );
  }

  if (isError) {
    return <p>{error?.data?.message || "Something went wrong"}</p>;
  }

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        py: 8,
      }}
    >
      <Container maxWidth="md">
        <Stack spacing={3}>
          <Stack direction="row" justifyContent="space-between" spacing={4}>
            <Typography variant="h4">Edit Hero Model</Typography>
          </Stack>

          <Formik
            initialValues={{
              carId: heroModel?.carId || "",
            }}
            onSubmit={handleSubmit}
            validationSchema={validationSchema}
          >
            {({
              setFieldValue,
              values,
              setFieldTouched,
              setFieldError,
              errors,
            }) => (
              <Form>
                <Stack spacing={3}>
                  <FormInput
                    label="carId"
                    name="carId"
                    type="text"
                    placeholder="Enter carId"
                  />
                  <Button
                    type="submit"
                    variant="contained"
                    disabled={isUpdating}
                  >
                    Submit
                  </Button>
                </Stack>
              </Form>
            )}
          </Formik>
        </Stack>
      </Container>
    </Box>
  );
}
